import axios from '../modules/axios';

export default {
	namespaced: true,
	state: {
		open: false,
		data: null
	},
	mutations: {
		data(state, data) {
			state.data = data;
		},
		open(state, open) {
			state.open = open;
		}
	},
	actions: {
		async getData({commit}) {
			const {data} = await axios.get('/cart.js');
			commit('data', data);
		},
		async add({dispatch, commit}, {id, quantity}) {
			await axios.post('/cart/add.js', {id, quantity});
			await dispatch('getData');
			commit('open', true);
		},
		async change({dispatch}, {id, quantity}) {
			await axios.post('/cart/change.js', {id: id.toString(), quantity});
			await dispatch('getData');
		}
	},
	getters: {
		data(state) {
			return state.data;
		},
		open(state) {
			return state.open;
		}
	}
}
